import { SERVICES } from '@common/constants/Services';

export type SupportedLanguage = 'en' | 'uk' | 'tr';

const DEFAULT_LANGUAGES: readonly SupportedLanguage[] = ['en', 'uk'];

const SERVICE_LANGUAGES: Partial<Record<SERVICES, readonly SupportedLanguage[]>> = {
	[SERVICES.TIS]: ['en', 'tr'],
	[SERVICES.TRAINING_CENTER]: ['en'],
};

export const getServiceLanguages = (serviceId?: number): readonly SupportedLanguage[] =>
	(serviceId && SERVICE_LANGUAGES[serviceId as SERVICES]) || DEFAULT_LANGUAGES;

export const getLanguageForService = (language: string, serviceId?: number): SupportedLanguage => {
	const normalizedLanguage = language.toLocaleLowerCase() as SupportedLanguage;

	return getServiceLanguages(serviceId).includes(normalizedLanguage) ? normalizedLanguage : 'en';
};
